import visual from 'assets/images/community/visual.png';

export const krNotice = {
  title: `커뮤니티`,
  subTitle: `Community`,
  subject: `공지사항`,
  subjectDesc: `Notice`,
  visual,
  listBtn: '목록',
  prev: '이전',
  next: '다음',
  attachedFile: '첨부 파일',
  uploadFile: '파일 첨부',
  noticeTitle: '공지사항',
  noticeSubTitle: 'Notice',
  InquiryTitle: '견적문의',
  InquirySubTitle: 'Inquiry',
  InquiryName: '성함',
  InquiryTel: '연락처',
  InquirySubject: '문의 제목',
  InquiryContent: '문의 내용',
  InquiryBtn: '문의하기',
  qnaTitle: 'QNA',
  qnaSubTitle: 'QNA',
  archiveTitle: '자료실',
  archiveSubTitle: 'Archive',
  archive: '자료실',
  downloadBtn: '다운로드',
};

export const enNotice = {
  title: `커뮤니티_en`,
  subTitle: `Community`,
  visual,
  listBtn: 'list',
  prev: 'prev',
  next: 'next',
  attachedFile: '첨부 파일',
  uploadFile: '파일 첨부',
  noticeTitle: '공지사항',
  noticeSubTitle: 'Notice',
  InquiryTitle: '견적문의',
  InquirySubTitle: 'Inquiry',
  InquiryName: '성함',
  InquiryTel: '연락처',
  InquirySubject: '문의 제목',
  InquiryContent: '문의 내용',
  InquiryBtn: '문의하기',
  qnaTitle: 'QNA',
  qnaSubTitle: 'QNA',
  archiveTitle: '자료실',
  archiveSubTitle: 'Archive',
  archive: '자료실',
  downloadBtn: '다운로드',
};
